var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-result flex-ccc",style:(_vm.bodyStyle)},[_c('div',{staticClass:"no-result-img",class:_vm.type}),_c('div',[_vm._v(_vm._s(_vm.text || '暂无数据'))])])}
var staticRenderFns = []

export { render, staticRenderFns }